import React from 'react';
import bem from 'utils/bem';
import './index.sass';

const { block } = bem('pulsing-dot');

export const PulsingDot = ({idle}) => {
    return <span className={block({'idle': idle})}/>
}